module.exports = __webpack_public_path__ + "img/3f_l_newtokyo@2x.9750ce68.jpg";